import React from "react";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import './CurrentPriceStyles.css';
import { Card, Col, Row } from "react-bootstrap";
import { createPrice } from "../../../apis/options/StockPriceApi";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";

const schema = yup
  .object({
    price: yup.number().required(),
    effectiveStart: yup.date().required(),
    effectiveEnd: yup.date().notRequired()
  })
  .required()


const AddPriceForm = () => {

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm({
        resolver: yupResolver(schema)
    })

    const history = useHistory();

    const addPrice = (data) => 
    {
        createPrice(data)
        .then( _ => {
            history.push("/options/stockprice");
        })
        .catch( _ => {
            history.push("/options/stockprice");
        });
    }

    const handleCancel = _ => {
        history.push("/options/stockprice")
    }

    return (
        <Row>
        <Col>
            <Card style={{ width: '18rem' }}>
            <Card.Body>
                <Card.Title>New Price</Card.Title>
                <Card.Text>
                <Form noValidate 
                    onSubmit={handleSubmit(addPrice)}> 
                    <Form.Group>
                        <Form.Label>Stock Price</Form.Label>
                        <Form.Control isInvalid={!!errors.price} type="text" placeholder="Stock Price" {...register("price")} />
                        <Form.Control.Feedback type="invalid">
                        {errors.price?.message}
                        </Form.Control.Feedback>
                    </Form.Group>                  
                    <Form.Group>
                        <Form.Label>Effective Start Date</Form.Label>
                        <Form.Control isInvalid={!!errors.effectiveStart} type="date" placeholder="Start Date" { ...register("effectiveStart")} />
                        <Form.Control.Feedback type="invalid">{errors.effectiveStart?.message}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Effective End Date</Form.Label>
                        <Form.Control isInvalid={!!errors.effectiveEnd} type="date" placeholder="End Date" { ...register("effectiveEnd")} />
                        <Form.Control.Feedback type="invalid">{errors.effectiveEnd?.message}</Form.Control.Feedback>
                    </Form.Group>  
                    <Button variant="primary" type="submit">
                        Add
                    </Button>
                    <Button variant="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                </Form>
                </Card.Text>
            </Card.Body>
            </Card>            
        </Col>
        </Row>
    );

}

export default AddPriceForm;